import { createContext } from 'react'

import defaultProperties from './defaultProperties'

const ConfigContext = createContext({...defaultProperties });

export default ConfigContext ;